export const inputColors = {
    border: 'sandstone.60',
    placeholder: 'sandstone.55',
    inputText: 'sandstone.10',
    helpText: 'sandstone.30',
    icons: 'seaBlue.main',
    disabled: 'sandstone.95',
    focus: 'seaBlue.main',
    error: 'energyRed.45',
    loading: 'seaBlue.80',
    success: 'landGreen.41'
};
export const stateIcons = {
    error: 'falExclamationTriangle',
    loading: 'fadSpinnerThird',
    success: 'falCheck'
};
export const inputStateMapping = {
    error: {
        variant: 'red',
        iconProps: {
            color: inputColors.error,
            icon: stateIcons.error
        }
    },
    loading: {
        variant: 'grey',
        iconProps: {
            animation: 'vui-spin 0.6s linear infinite',
            name: stateIcons.loading,
            pathFill: [inputColors.loading, inputColors.icons]
        }
    },
    success: {
        variant: 'green',
        iconProps: {
            color: inputColors.success,
            icon: stateIcons.success
        }
    }
};
